module.exports = __webpack_public_path__ + "img/03-Kombi.39ab548e.svg";